import { render, staticRenderFns } from "./declarationSummaryStatistics.vue?vue&type=template&id=7f5a0f7c&scoped=true&"
import script from "./declarationSummaryStatistics.vue?vue&type=script&lang=js&"
export * from "./declarationSummaryStatistics.vue?vue&type=script&lang=js&"
import style0 from "./declarationSummaryStatistics.vue?vue&type=style&index=0&id=7f5a0f7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5a0f7c",
  null
  
)

export default component.exports